import React from 'react';
import clsx from 'clsx';
import { formatQuantity } from '../../../../../utils/inventoryLabels';

/** From this share of its capacity on, a location is about to fill up. */
const NEARLY_FULL_PCT = 85;

/**
 * How much there is in a location, against how much fits.
 *
 * The occupancy is not a stored field: the server adds it up from the kardex,
 * so it cannot disagree with it. A capacity of zero means no limit, and then
 * there is no bar to draw. Going over the limit is shown, not hidden — the
 * system warns and does not block, because the goods are physically there.
 *
 * @param {object} props
 * @param {object} props.slot - As `slots/` answers it.
 */
export const OccupancyCell = ({ slot }) => {
  const occupancy = formatQuantity(slot.occupancy);

  if (slot.usage_pct === null) {
    return (
      <div className="flex flex-col">
        <span className="font-semibold tabular-nums">{occupancy} un</span>
        <span className="text-xs text-text-muted mt-0.5">Sin límite</span>
      </div>
    );
  }

  const isOver = slot.usage_pct > 100;

  return (
    <div className="flex flex-col min-w-[120px]" title={`${slot.usage_pct}% ocupada`}>
      <span className="font-semibold tabular-nums">
        {occupancy} / {formatQuantity(slot.capacity)} un
      </span>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.min(slot.usage_pct, 100)}
        aria-label={`Ocupación de ${slot.name}`}
        data-testid="slot-occupancy-bar"
        className="mt-1.5 h-1.5 rounded-full bg-ninja-gray dark:bg-[#2d2d2d] overflow-hidden"
      >
        <div
          className={clsx(
            'h-full rounded-full',
            isOver
              ? 'bg-danger'
              : slot.usage_pct > NEARLY_FULL_PCT
                ? 'bg-warning'
                : 'bg-ninja-green'
          )}
          style={{ width: `${Math.min(slot.usage_pct, 100)}%` }}
        />
      </div>
    </div>
  );
};
